import React, { useState, useRef, useEffect} from 'react';
import { Link } from 'gatsby';
import style from './navigation.module.css';
import Button from './button';
import useWindowSize from '../hooks/useWindowSize';
import OhCleoLogoPink from '../../static/images/OhCleo__Pink.svg'
import OhCleoLogoGreen from '../../static/images/ohcleo-logo.svg'
// import { FullStore } from '../contexts/fullContext';

export default function Navigation({
  showBecomeContentCreator = true,
  showTransparentNav = true,
  showDarkStyling = false,
}) {
  // const { dispatch, state } = useContext(FullStore);
  const { isMobile } = useWindowSize();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const [navBackground, setNavBackground] = useState(false);
  const [darkStyling, setDarkStyling] = useState(false);

  const navRef = useRef();
  navRef.current = navBackground;

  //check if user started scrolling / is mid page
  const isScrolling = () => {
    if (typeof window !== 'undefined') {
      if(window.scrollY > 70) {
        return true
      } else {
        return false
      }
  }};

  useEffect(() => {
    const handleScroll = () => {
      const show = isScrolling()
      if (navRef.current !== show) {
        setNavBackground(show);
        setDarkStyling(show)
      }
    };
    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  //mobile nav behaviour and style 
  useEffect(() => {
    if (mobileNavOpen && isMobile) {
      document.body.classList.add('no-scroll', 'to-fixed');
      setDarkStyling(true);
    } 
    else {
      document.body.classList.remove('no-scroll', 'to-fixed');
      setDarkStyling(false)
    }
    if(!isMobile ) {
      setMobileNavOpen(false)
    }
  }, [mobileNavOpen, isMobile]);

  function toggleMobileNavOpen() {
    setMobileNavOpen(!mobileNavOpen);
  }

  useEffect(() => {
    showDarkStyling ? setDarkStyling(true) : null
    isScrolling() ? setDarkStyling(true) : null
    !showTransparentNav && mobileNavOpen ? setDarkStyling(true) : null 
  }, [darkStyling])

  function renderMenuItems() {
    return (
    <div className={style.menuItems}>
          <Link to="/about" style={{color: !darkStyling ? 'var(--third-color)': '#ffffff'}} activeStyle={{fontWeight: "bold"}}>About</Link>
          <Link to="/blog" style={{color: !darkStyling ? 'var(--third-color)': '#ffffff'}} activeStyle={{fontWeight: "bold"}}>Blog</Link>
          <Link to="/press" style={{color: !darkStyling ? 'var(--third-color)': '#ffffff'}} activeStyle={{fontWeight: "bold"}}>Press</Link>
        </div>
    );
  }
  const renderMobileMenu = () => {
    if (mobileNavOpen) {
      return (
        <img
          src={darkStyling ? "/images/times-white.svg" : "/images/times.svg"}
          alt="close"
          className={style.mobileMenu}
          onClick={() => toggleMobileNavOpen()}
        />
      );
    }
    return (
      <img
        src={darkStyling ? "/images/menu-white.svg" : "/images/menu.svg"}
        alt="menu"
        className={style.mobileMenu}
        onClick={() => toggleMobileNavOpen()}
      />
    );
  };

  return (
    <div
      className={style.wrapper}
      style={{
        backgroundColor:
          navBackground || showTransparentNav ? 'var(--third-color)' : 'transparent',
        boxShadow: navBackground ? '0px 4px 4px rgba(250, 179, 170, 0.03)' : null
      }}
    >
      <nav
        className={
          mobileNavOpen
            ? `${style.fullHeight} ${style.container}`
            : style.container
        }
      >
        <div className={style.content} 
             style={{backgroundColor: mobileNavOpen ? 'var(--third-color)' : "",
                      paddingTop: mobileNavOpen ? '11px' : ""}}>
          {renderMenuItems()}
          <Link to="/">
            {darkStyling ? <img
             height="45px"
             src={OhCleoLogoPink}
             alt="Oh Cleo logo"
            /> : <img
            height="45px"
            src={OhCleoLogoGreen}
            alt="Oh Cleo logo"
          />
            }
          </Link>
          <span className={style.hideButton}>
            <Button
              title="Content Creator"
              type={!darkStyling ? "secondary" : "pink"}
              link="/become-content-creator"
              invisible={!showBecomeContentCreator}
            />
            {/* {
            state.auth.jwt ? <Button className={style.loginBtn}
                                      title="Logout"
                                      type="secondary"
                                      onClick={() => {
                                        dispatch({
                                          type: 'AUTH_DISPOSE_TOKEN'
                                        })
                                      }}
                                      
                                    /> : <Button className={style.loginBtn}
                                    type="secondary"
                                    link="/login"
                                    title="Login"
                               />
          } */}
          </span>
          {renderMobileMenu()}
        </div>
        {mobileNavOpen && (
          <div className={style.mobileNav}>
            <div className={style.mobileNavContent}>
            <div className={style.menuItems}>
               <Link to="/about" style={{color: '#ffffff'}} activeStyle={{fontWeight: "bold"}}>About</Link>
               <Link to="/blog" style={{color: '#ffffff'}} activeStyle={{fontWeight: "bold"}}>Blog</Link>
               <Link to="/press" style={{color: '#ffffff'}} activeStyle={{fontWeight: "bold"}}>Press</Link>
               </div>
              {showBecomeContentCreator && (
                <Button
                  title="Content Creator"
                  type="pink"
                  link="/become-content-creator"
                />
              )}
            </div>
          </div>
        )}
      </nav>
    </div>
  );
}
